module.exports = __webpack_public_path__ + "img/now.72415440.svg";